import React from 'react'
import { loginbg, logo } from '../assets'
import SignIn from '../components/SignIn'

const Auth = () => {
 


  return (
    <div className="auth h-screen text-sm">
        <div className="relative flex flex-col justify-center items-center -z-10 h-1/3 lg:h-2/3 upper">
          <img src={loginbg} className='absolute flex justify-center items-center -z-10 w-full h-full object-cover rounded-bl-[5rem] ' alt="" />
            <div className=' lg:absolute top-10 flex flex-col gap-4 pt-4 items-center justify-center'>
                <img src={logo} alt="logo-img" />
                <p className='text-white'>Online Project Management</p>
            </div>
        </div>
        <div className='lg:fixed inset-0 flex items-center justify-center lg:items-end w-full bottom-20'>
            <SignIn />
        </div>
    </div>
  )
}

export default Auth;
